import React, {Component} from "react";
import {Drawer, Rate} from "antd";
import moment from "moment-timezone";
import {CloseOutlined} from '@ant-design/icons';
import {map} from "lodash"

class ViewServiceHistory extends Component {
  state = {
    serviceHistory: {}
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    // get service history
    if (Object.keys(nextProps?.service?.serviceHistory).length > 0
      && JSON.stringify(nextProps?.service?.serviceHistory) !== JSON.stringify(this.state.serviceHistory)) {
      this.setState({ serviceHistory: nextProps?.service?.serviceHistory });
    }
  }

  render() {
    const {closeDrawer, visible, currentHistory} = this.props;
    const {serviceHistory} = this.state;
    return (
      <Drawer
        placement={'right'}
        closable={false}
        onClose={closeDrawer}
        visible={visible}
        key={'right'}
        width={'400'}
        className="drawer-wrapper"
      >
        <div className="filter_drawer_wrapper  rdrawer">          
          <div className="card-head flex ai-center">
            <h4>View Service History</h4>
            <CloseOutlined onClick={closeDrawer}/>
          </div>            
          <div className="card-row">
            {serviceHistory?.results?.length > 0 ?
              map(serviceHistory?.results, x => {
                return (<div className="card-full flex flex-column">
                  <b>{`${moment(currentHistory?.scheduled_time).format('MMM DD, YYYY hh:mm A')}`}</b>
                  <span className="d-block mt-10">Weekly recurring service</span>
                  <span>{`Service by ${x?.technician?.first_name ? `${x?.technician?.first_name} ${x?.technician?.last_name}` : '-'}`}</span>
                  <span className="d-block mt-10">
                    <strong>{`${x?.technician?.first_name ? `${x?.technician?.first_name} ${x?.technician?.last_name}` : '-'} said:`}</strong> {x?.technician_notes}
                  </span>
                  <span>
                    <strong className="d-block mt-10">Customer Feedback</strong>
                    <Rate allowHalf value={x?.rating} disabled />
                    <span>{currentHistory?.comment}</span>
                  </span>
                </div>
                )
              }) : <div className="card-full flex flex-column"><b>No History</b></div>
            }
          </div>
          <div className="footer">
            <button
              // type="submit"
              className={`btn btn-warning`}
              onClick={closeDrawer}>
              Close
            </button>
          </div>
        </div>
      </Drawer>

    )
  }
}

export default ViewServiceHistory;
